/** @format */

/* eslint-disable */
import React from 'react'
import Transactions from '../../../../../Components/ReUsables/GLAccounts/Transactions'
import BreadCrumb from '../../../../../Components/BreadCrumb/Index'
import localize from '../../../../../Global/Localize'

function GLAccountTransactions() {
  return (
    <>
      <BreadCrumb
        tree={[
          localize('accountsManagement'),
          localize('transactionsJournal'),
          localize('gLAccountTransactions'),
        ]}
      />
      <div className="card bg-white rounded">
        <div className="card-body">
          <Transactions glAccount={null} />
        </div>
      </div>
    </>
  )
}

export default GLAccountTransactions
